import * as React from 'react';
import { styles } from './styles';
import InlineSVG from 'svg-inline-react';
import { cx } from 'emotion';
import SlidingPane from 'react-sliding-pane';
import { Icon } from '@withjoy/joykit';
import { JoyLogo } from '@components/JoyLogo';
import './popup.css';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Analytics } from '@withjoy/web-core';
import { MarketingNavItem, FeatureNavItem, MarketingNavKey } from '../../index';
const searchSvg = require('@assets/icons/icon-search.svg');

interface MobileNavProps {
  mobileNavOpen: boolean;
  handleMobileNavOpen: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
  handleMobileNavClose: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
  analytics: Analytics;
  marketingNavItems: MarketingNavItem[];
  featureNavItems: FeatureNavItem[];
}

interface MobileState {
  featuresIsOpen: boolean;
}

export class MobileMarketingNav extends React.PureComponent<MobileNavProps, MobileState> {
  state: MobileState = {
    featuresIsOpen: false
  };

  componentDidUpdate(prevProps: MobileNavProps) {
    if (this.props.mobileNavOpen !== prevProps.mobileNavOpen) {
      const targetEl = document.querySelector('#mobile-marketing-nav');
      if (!this.props.mobileNavOpen) {
        enableBodyScroll(targetEl);
      } else {
        disableBodyScroll(targetEl);
      }
    }
  }

  componentWillUnmount() {
    const targetEl = document.querySelector('#mobile-marketing-nav');
    enableBodyScroll(targetEl);
  }

  handleToggleFeatures = () => {
    this.props.analytics.track({
      action: 'FeaturesToggle',
      label: 'features'
    });

    this.setState((state: MobileState) => {
      return {
        featuresIsOpen: !state.featuresIsOpen
      };
    });
  };

  render(): React.ReactNode {
    const { marketingNavItems, featureNavItems, analytics } = this.props;
    return (
      <div className={styles.mobileHeader}>
        <a aria-label="Go to withjoy.com" className={styles.flexLogo} href="https://withjoy.com/">
          <JoyLogo />
        </a>
        <div className={styles.buttonWrapper}>
          <div className={styles.getStartedWrapper}>
            <a href="https://withjoy.com/createwedding" className={styles.navButton}>
              Get Started
            </a>
          </div>
          <div className={styles.menuWrapper}>
            <a className={styles.navButton} onClick={this.props.handleMobileNavOpen}>
              Menu
            </a>
          </div>
        </div>
        <SlidingPane
          closeIcon={<Icon source="close" />}
          width="70vw"
          from="right"
          isOpen={this.props.mobileNavOpen}
          overlayClassName={styles.popupPosition}
          onRequestClose={this.props.handleMobileNavClose}
        >
          <nav className={styles.container}>
            <ul className={styles.listContainer}>
              {marketingNavItems.map(({ text, url, key, track }) => {
                const isDesign = key === MarketingNavKey.designs;
                const isFeatures = key === MarketingNavKey.features;
                return isFeatures ? (
                  <React.Fragment key="featureSubmenu">
                    <li key={text} className={styles.listItem}>
                      <a className={cx(styles.navLink, isFeatures && 'active')} onClick={this.handleToggleFeatures}>
                        {text}
                      </a>
                    </li>
                    <ul className={styles.featuresContainer(this.state.featuresIsOpen)}>
                      {featureNavItems.map(({ text: featureText, url: featureUrl, track: featureTrack }) => {
                        return (
                          <li key={featureText} className={styles.listItem}>
                            <a
                              className={cx(styles.navLink, false)}
                              href={featureUrl}
                              onClick={() => analytics.track(featureTrack)}
                            >
                              {featureText}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </React.Fragment>
                ) : (
                  <li key={text} className={styles.listItem}>
                    <a
                      className={cx(styles.navLink, isDesign && 'active')}
                      href={isDesign ? undefined : url}
                      onClick={() => analytics.track(track)}
                    >
                      {text}
                    </a>
                  </li>
                );
              })}
              <li className={styles.listItem}>
                <a className={styles.navButton} href="https://withjoy.com/find">
                  <InlineSVG src={searchSvg} className={styles.svg} />
                  <span>Find a Couple</span>
                </a>
              </li>
            </ul>
          </nav>
        </SlidingPane>
      </div>
    );
  }
}
